import React, { Component } from 'react';
import { equals } from 'ramda';
import PropTypes from 'prop-types';
import { transformAllValues } from 'utils/functions';
import YesNoQuestion from './YesNoQuestion';
import { YES } from './YesNoQuestionnaire.constants';

class YesNoQuestionnaire extends Component {
  state = {
    answers: {}
  };

  processAnswers = () => {
    const { answers } = this.state;
    const { questions, onAllAnswersSelected } = this.props;

    if (questions.every((question) => answers[question.name])) {
      onAllAnswersSelected(transformAllValues(equals(YES), answers));
    }
  };

  onChange = ({ target: { name: question, value: answer } }) => {
    this.setState(
      ({ answers }) => ({
        answers: {
          ...answers,
          [question]: answer
        }
      }),
      () => {
        this.processAnswers();
      }
    );
  };

  render() {
    const { questions } = this.props;
    const { answers } = this.state;

    return (
      <>
        {questions.map(({ name, legend }) => (
          <YesNoQuestion key={name} name={name} legend={legend} selectedValue={answers[name]} onChange={this.onChange} />
        ))}
      </>
    );
  }
}

YesNoQuestionnaire.propTypes = {
  onAllAnswersSelected: PropTypes.func.isRequired,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      legend: PropTypes.node.isRequired
    })
  ).isRequired
};

export default YesNoQuestionnaire;
